export default __webpack_public_path__ + "static/media/pixellab--graphic-design--01--600x450.ac1929ff.jpg";